export const translations = {
  de: {
    // Meta
    meta: {
      title: "Pflege & Seniorenbetreuung auf Mallorca – Deutschsprachige Hilfe im Alltag | Geis Care",
      description: "Diplomierte Krankenschwester mit 15+ Jahren Erfahrung bietet Seniorenbetreuung Mallorca deutsch, Alltagshilfe Mallorca deutsch, Pflege Mallorca deutsch – Körperpflege, Mobilität, Wundversorgung, 24h-Betreuung.",
      keywords: "Seniorenbetreuung Mallorca deutsch, Alltagshilfe Mallorca deutsch, Pflege Mallorca deutsch, Betreuung zuhause Mallorca, Begleitung Arzt Mallorca deutsch, Hausbesuche Mallorca Pflege, 24h Pflege Mallorca, Diplomierte Krankenschwester Mallorca"
    },
    // Hero
    hero: {
      title: "Exklusive Pflege & Begleitung auf Mallorca",
      subtitle: "Ruhig, achtsam, professionell.",
      cta1: "Erstgespräch anfragen",
      cta2: "Leistungen ansehen",
      tagline: "Würde. Kompetenz. Vertrauen.",
      titlePart1: "Exklusive Pflege ",
      titlePart2: " Begleitung auf Mallorca",
      urgency: "Nur noch 3 frei im April",
      badge1: "15+ Jahre Erfahrung",
      badge2: "Diplomierte Pflege",
      badge3: "24/7 Betreuung",
      scroll: "Scroll"
    },
    // About
    about: {
      title: "Über Tutku Geis",
      text1: "Ich bin Tutku Geis, diplomierte Krankenschwester mit über 15 Jahren Erfahrung in der Intensiv- und OP-Pflege.",
      text2: "Ich begleite Menschen mit Ruhe, Würde und Herz – persönlich, individuell und mit einem offenen Ohr."
    },
    // USP
    usp: {
      title: "Warum Geis Care",
      label: "Warum Geis Care",
      subtitle: "Vier Säulen exzellenter Pflege, die uns auszeichnen",
      ctaText: "Erleben Sie den Unterschied erstklassiger Pflege",
      ctaButton: "Jetzt Kontakt aufnehmen",
      items: [
        {
          title: "Diplomierte Expertise",
          text: "Pflege auf höchstem Niveau."
        },
        {
          title: "Diskret & zuverlässig",
          text: "Vertrauen ab der ersten Minute."
        },
        {
          title: "Individuell & menschlich",
          text: "Zeit, Nähe, Würde."
        },
        {
          title: "Ruhige Verbindung",
          text: "Ehrlich und unaufgeregt."
        }
      ]
    },
    // Senior Care
    seniorCare: {
      label: "Seniorenbetreuung",
      title: "Individuelle Seniorenbetreuung auf Mallorca",
      subtitle: "Professionelle deutschsprachige Unterstützung für ein selbstbestimmtes Leben",
      description: "Unsere Seniorenbetreuung Mallorca deutsch bietet Ihnen umfassende Alltagshilfe Mallorca deutsch – von der Betreuung zuhause Mallorca bis zur Begleitung Arzt Mallorca deutsch. Wir bieten Hausbesuche Mallorca Pflege mit Herz und Kompetenz.",
      ctaButton: "Jetzt unverbindlich anfragen",
      items: [
        {
          icon: "home",
          title: "Unterstützung im Alltag",
          description: "Hilfe bei täglichen Routinen für mehr Lebensqualität"
        },
        {
          icon: "medical",
          title: "Begleitung zu Arztterminen",
          description: "Sicher und zuverlässig zu allen medizinischen Terminen"
        },
        {
          icon: "pill",
          title: "Medikamenten-organisation",
          description: "Strukturierte Verwaltung und Einnahmeüberwachung"
        },
        {
          icon: "house",
          title: "Hilfe im Haushalt",
          description: "Unterstützung bei alltäglichen Haushaltsaufgaben"
        },
        {
          icon: "care",
          title: "Körperpflege Unterstützung",
          description: "Würdevolle Hilfe bei der persönlichen Hygiene"
        },
        {
          icon: "heart",
          title: "Gesellschaft leisten",
          description: "Gemeinsame Zeit und soziale Kontakte"
        },
        {
          icon: "walk",
          title: "Spaziergänge",
          description: "Begleitete Ausflüge an der frischen Luft"
        },
        {
          icon: "shopping",
          title: "Begleitung zu Einkäufen",
          description: "Gemeinsame Besorgungen und Erledigungen"
        }
      ]
    },
    // Services
    services: {
      title: "Unsere Leistungen",
      subtitle: "Flexible Betreuung, individuell auf Sie zugeschnitten.",
      categories: [
        {
          title: "Körperliche Pflege",
          description: "Unterstützung im Alltag:",
          items: [
            "✓ Körperpflege (Waschen, Duschen, Baden)",
            "✓ An- und Auskleiden",
            "✓ Mobilität & Aktivierung",
            "✓ Medikamentengabe",
            "✓ Wundversorgung",
            "✓ Ernährung & Flüssigkeit"
          ],
          footer: "Alles wird dokumentiert – Sie haben jederzeit Einblick."
        },
        {
          title: "Besondere Betreuung",
          description: "Betreuung, die über das Gewöhnliche hinausgeht:",
          items: [
            "✓ Urlaubs- & Anlassbegleitung",
            "✓ Stunden- oder Tagespflege",
            "✓ 24-Stunden-Begleitung",
            "✓ Soziale Aktivitäten & Ausflüge",
            "✓ Begleitung zu Arztterminen"
          ],
          footer: "Individuell auf Ihre Situation zugeschnitten."
        },
        {
          title: "Entlastung & Organisation",
          description: "Entlastung für Sie und Ihre Familie:",
          items: [
            "✓ Arzt- und Therapiebegleitung",
            "✓ Termin- & Medikationsplanung",
            "✓ Angehörigen-Entlastung (Mallorca & Deutschland)",
            "✓ Transparenz durch Dokumentation",
            "✓ Notfallplanung & Krisenmanagement"
          ],
          footer: "Wir sind Ihre Augen und Ohren vor Ort."
        }
      ]
    },
    // ServicesNew (3 pillars)
    servicesNew: {
      label: "Unsere 3 Säulen",
      ctaQuestion: "Haben Sie Fragen zu unseren Leistungen?",
      ctaButton: "Jetzt kostenlos beraten lassen"
    },
    // ServicesDirectory
    servicesDirectory: {
      label: "Leistungsverzeichnis",
      ctaQuestion: "Haben Sie Fragen zu unseren Leistungen?",
      ctaButton: "Jetzt kostenlos beraten lassen"
    },
    // Testimonials
    testimonials: {
      title: "Was Kunden sagen",
      items: [
        {
          text: "Frau Geis hat uns in einer schweren Zeit mit so viel Herz und Professionalität unterstützt. Wir wussten unsere Mutter in den besten Händen.",
          author: "Maria S.",
          location: "Port d'Andratx"
        },
        {
          text: "Endlich eine Pflege, die nicht nach der Uhr, sondern nach dem Menschen schaut. Absolut diskret und zuverlässig.",
          author: "Thomas K.",
          location: "Son Vida"
        }
      ]
    },
    // Service Area
    serviceArea: {
      title: "Unser Einsatzgebiet auf Mallorca",
      subtitle: "Wir sind in den Premium-Regionen Mallorcas für Sie da",
      regions: [
        "Manacor", "Porto Cristo", "Cala Millor", "Artà", "Capdepera",
        "Santanyí", "Campos", "Son Vida", "Port d'Andratx", "Palma Altstadt",
        "und weitere Regionen"
      ]
    },
    // Contact
    contact: {
      title: "Lassen Sie uns sprechen.",
      subtitle: "Wir melden uns zeitnah und diskret.",
      email: "E-Mail",
      phone: "Telefon",
      whatsapp: "Auch per WhatsApp möglich.",
      area: "Einsatzgebiet",
      areaText: "Manacor, Porto Cristo, Cala Millor, Artà, Capdepera, Santanyí, Campos, Son Vida, Port d'Andratx, Palma Altstadt",
      areaExtra: "und weitere Regionen Mallorcas",
      formName: "Name",
      formNamePlaceholder: "Ihr Name",
      formPhone: "Telefon",
      formPhonePlaceholder: "+49 ...",
      formEmail: "E-Mail",
      formEmailPlaceholder: "name@beispiel.de",
      formMessage: "Nachricht",
      formMessagePlaceholder: "Wie können wir Ihnen helfen?",
      formPrivacy: "Ich stimme der Verarbeitung meiner Daten zum Zweck der Kontaktaufnahme zu.",
      formPrivacyLink: "(Datenschutzerklärung)",
      formSubmit: "Nachricht senden",
      formConfirmation: "Danke! Wir melden uns zeitnah und diskret."
    },
    // Header
    header: {
      about: "Über mich",
      services: "Leistungen",
      blog: "Blog",
      why: "Warum wir",
      contact: "Kontakt",
      shop: "Shop"
    },
    // For Whom
    forWhom: {
      title: "Die perfekte Lösung für...",
      subtitle: "...alle, die sich liebevolle und zuverlässige Unterstützung wünschen.",
      cards: [
        {
          title: "Senioren auf Mallorca",
          text: "...die ihre Unabhängigkeit bewahren und sicher in ihrer gewohnten Umgebung leben möchten. Mit GEIS CARE erhalten Sie die Unterstützung, die Sie brauchen – ohne Ihre Freiheit zu verlieren."
        },
        {
          title: "Angehörige in der DACH-Region",
          text: "...die aus der Ferne die bestmögliche Betreuung für ihre Liebsten sicherstellen und dabei entlastet werden möchten. Unsere digitale Dokumentation gibt Ihnen Seelenruhe – Sie wissen, alles ist in besten Händen."
        },
        {
          title: "Langzeiturlauber & Überwinterer",
          text: "...die während ihres Aufenthalts auf Mallorca nicht auf Sicherheit und soziale Kontakte verzichten möchten. Genießen Sie Ihren Traum von Mallorca – wir kümmern uns um Ihre Sicherheit und Ihr Wohlbefinden."
        },
        {
          title: "Enkelkinder & Freunde",
          text: "...die ihren Großeltern sinnvolle Geschenke aus unseren Shops machen möchten. Schenken Sie nicht nur ein Produkt – schenken Sie Aufmerksamkeit und Liebe."
        }
      ]
    },
    // Digital Products
    digitalProducts: {
      title: "Wissen, das Sicherheit gibt.",
      text1: "Entdecken Sie unsere digitalen Helfer für den Pflegealltag – von Notfall-Checklisten bis zu rechtssicheren Vorlagen.",
      text2: "In unserem Shop finden Sie digitale Produkte, die Ihnen helfen, den Pflegealltag zu organisieren und rechtliche Fallstricke zu vermeiden.",
      text3: "Jedes Produkt wurde sorgfältig entwickelt, um echte Probleme zu lösen:",
      items: [
        "Notfall-Handbücher für schnelles Handeln",
        "Checklisten zur Vermeidung von Medikationsfehlern",
        "Rechtliche Vorlagen für Sicherheit",
        "Video-Kurse für praktisches Wissen"
      ],
      cta: "Zum Hauptshop"
    },
    // Gift Boxes
    giftBoxes: {
      title: "Mediterrane Qualität aus dem Herzen der Natur.",
      text1: "Entdecken Sie unsere handverlesenen Produkte – BIO-Kräutertees, ätherische Öle und edle Wohntextilien aus dem Mittelmeerraum.",
      subtitle: "Aus unserem Shop:",
      items: [
        "MOLY BIO-Kräutertees – Ironwort, Zitronenmelisse, Digestion & mehr",
        "Ätherische BIO-Öle – Lavendel, Eukalyptus, Pfefferminz, Orange",
        "Premium-Wohntextilien – Decken, Kissen, Fußmatten (recycelt & handgewebt)",
        "Digitale Vorsorge-Notfallmappe für Angehörige"
      ],
      note: "Alle Produkte sind sorgfältig ausgewählt – für Wohlbefinden, Würde und Lebensqualität.",
      cta1: "Zum Shop",
      cta2: "Zum TikTok Shop"
    },
    // Process
    process: {
      title: "In 3 Schritten zur sorgenfreien Betreuung.",
      subtitle: "Unser Prozess ist einfach, transparent und auf Ihre Bedürfnisse zugeschnitten.",
      steps: [
        {
          title: "Kostenloses Erstgespräch",
          text: "Sie schildern Ihre Situation. Wir hören zu und entwickeln gemeinsam eine erste Idee für die passende Unterstützung. Keine versteckten Kosten, keine Verpflichtung – nur ehrliche Beratung.",
          duration: "Dauer: Ca. 20-30 Minuten (telefonisch oder persönlich)"
        },
        {
          title: "Persönliche Bedarfsanalyse",
          text: "Wir erstellen eine detaillierte Bedarfs- und Wunschanalyse vor Ort, um ein maßgeschneidertes Pflegekonzept zu entwickeln. Das ist die Grundlage für ein perfektes Matching.",
          duration: "Dauer: Ca. 1-2 Stunden"
        },
        {
          title: "Start der Betreuung",
          text: "Unsere sorgfältig ausgewählte Pflegekraft beginnt mit der Betreuung. Als Angehöriger erhalten Sie Zugang zur digitalen Dokumentation und haben jederzeit volle Transparenz. Die Betreuung läuft kontinuierlich und wird regelmäßig optimiert.",
          duration: "Dauer: Fortlaufend"
        }
      ]
    },
    // FAQ
    faq: {
      title: "Häufig gestellte Fragen",
      subtitle: "Hier finden Sie Antworten auf die wichtigsten Fragen zu GEIS CARE.",
      items: [
        {
          question: "Was kostet die Betreuung durch GEIS CARE?",
          answer: "Die Kosten variieren je nach Umfang und Art der Betreuung. In unserem kostenlosen Erstgespräch erstellen wir ein individuelles Angebot, das genau auf Ihre Bedürfnisse zugeschnitten ist. Wir legen großen Wert auf Transparenz – es gibt keine versteckten Kosten."
        },
        {
          question: "Wie funktioniert die digitale Dokumentation?",
          answer: "Alle Pflegemaßnahmen werden in Echtzeit digital dokumentiert. Als Angehöriger erhalten Sie Zugang zu einer sicheren Plattform, auf der Sie jederzeit sehen können, welche Maßnahmen durchgeführt wurden, wie es Ihrem Angehörigen geht und welche Termine anstehen. So haben Sie jederzeit volle Transparenz."
        },
        {
          question: "Welche Qualifikationen haben Ihre Pflegekräfte?",
          answer: "Alle unsere Pflegekräfte sind diplomierte Krankenschwestern mit mehrjähriger Berufserfahrung. Tutku Geis, unsere Gründerin, hat 15 Jahre Erfahrung in der Intensiv- und OP-Pflege. Wir legen großen Wert auf kontinuierliche Weiterbildung und menschliche Kompetenz."
        },
        {
          question: "Können Sie auch kurzfristig einspringen?",
          answer: "Ja, in vielen Fällen können wir auch kurzfristig Unterstützung anbieten. Kontaktieren Sie uns telefonisch oder per WhatsApp, und wir finden gemeinsam eine Lösung. Für Notfälle haben wir ein spezielles Bereitschaftssystem."
        },
        {
          question: "Arbeiten Sie auch mit deutschen Ärzten und Therapeuten zusammen?",
          answer: "Ja, wir haben ein ausgezeichnetes Netzwerk an deutschsprachigen Ärzten, Therapeuten und Spezialisten auf Mallorca. Bei Bedarf begleiten wir Sie zu Terminen und stellen sicher, dass alle medizinischen Informationen korrekt dokumentiert und kommuniziert werden."
        },
        {
          question: "Bieten Sie auch Betreuung für Menschen mit Demenz an?",
          answer: "Ja, wir haben spezielle Erfahrung in der Betreuung von Menschen mit Demenz und anderen kognitiven Beeinträchtigungen. Unsere Pflegekräfte sind im Umgang mit herausforderndem Verhalten geschult und legen großen Wert auf würdevolle, einfühlsame Begleitung."
        }
      ],
      extraQuestion: "Haben Sie weitere Fragen?",
      cta: "Kontaktieren Sie uns"
    },
    // Privacy & Impressum
    privacy: {
      backButton: "Zurück zur Startseite",
      title: "Datenschutzerklärung"
    },
    impressum: {
      backButton: "Zurück zur Startseite",
      title: "Impressum"
    },
    // Blog
    blog: {
      title: "Wissenswertes & Einblicke",
      subtitle: "Aktuelle Beiträge rund um Pflege, Betreuung und Leben auf Mallorca.",
      readMore: "Weiterlesen",
      showLess: "Weniger anzeigen"
    },
    // Cookie Banner
    cookies: {
      title: "Cookies & Datenschutz",
      description: "Wir verwenden Cookies, um unsere Website sicher zu betreiben und sie für Sie zu verbessern. Technisch notwendige Cookies setzen wir auf Basis unseres berechtigten Interesses. Alle weiteren Cookies verwenden wir nur, wenn Sie zustimmen. Weitere Informationen finden Sie in unserer Datenschutzerklärung.",
      acceptAll: "Alle akzeptieren",
      rejectAll: "Nur notwendige Cookies",
      settings: "Einstellungen",
      savePreferences: "Auswahl speichern",
      privacyLink: "Datenschutzerklärung",
      settingsTitle: "Cookie-Einstellungen",
      necessary: "Notwendige Cookies",
      necessaryDesc: "Diese Cookies sind für den Betrieb der Website erforderlich.",
      alwaysActive: "Immer aktiv",
      statistics: "Statistik",
      statisticsDesc: "Helfen uns zu verstehen, wie Besucher mit der Website interagieren, um sie zu verbessern.",
      marketing: "Marketing",
      marketingDesc: "Werden verwendet, um Besuchern relevante Werbung und Marketingkampagnen anzuzeigen."
    },

    // Footer
    footer: {
      tagline: "Exklusive Pflege & Begleitung auf Mallorca",
      impressum: "Impressum",
      privacy: "Datenschutz",
      cookieSettings: "Cookie",
      contact: "Kontakt",
      rights: "Alle Rechte vorbehalten.",
      quickLinks: "Schnellzugriff",
      about: "Über uns",
      services: "Leistungen",
      testimonials: "Erfahrungen",
      followUs: "Folgen Sie uns",
      contactTitle: "Kontakt",
      whatsapp: "WhatsApp verfügbar",
      madeWith: "Made with",
      inMallorca: "auf Mallorca",
      developedWith: "Entwickelt mit",
      forCare: "für erstklassige Pflege",
      seoTitle: "Unsere Leistungen",
      seoKeywords: [
        "Pflege auf Mallorca",
        "Seniorenbetreuung Mallorca",
        "Alltagshilfe Mallorca",
        "Arztbegleitung Mallorca",
        "Deutschsprachige Betreuung Mallorca"
      ]
    }
  },
  en: {
    // Meta
    meta: {
      title: "German-speaking Home Care & Daily Assistance in Mallorca | Geis Care",
      description: "Certified nurse with 15+ years experience offers home care Mallorca, elderly assistance Mallorca, German caregiver Mallorca – personal care, mobility, wound care, 24h support.",
      keywords: "home care Mallorca, elderly assistance Mallorca, German caregiver Mallorca, senior care Mallorca, nursing Mallorca, 24h care Mallorca, certified nurse Mallorca"
    },
    // Hero
    hero: {
      title: "Exclusive Care & Accompaniment in Mallorca",
      subtitle: "Certified Nursing – calm, mindful, professional.",
      cta1: "Request Initial Consultation",
      cta2: "View Services",
      tagline: "Dignity. Competence. Trust.",
      titlePart1: "Exclusive Care ",
      titlePart2: " Accompaniment in Mallorca",
      urgency: "Only 3 spots left for April",
      badge1: "15+ Years Experience",
      badge2: "Certified Nursing",
      badge3: "24/7 Care",
      scroll: "Scroll"
    },
    // About
    about: {
      title: "About Tutku Geis",
      text1: "I am Tutku Geis, a certified nurse from Germany with over 15 years of experience in intensive care and surgical nursing. I accompany people with calm, dignity, and heart.",
      text2: "With Geis Care, I offer you care that goes beyond the ordinary: personal, individual, and with an open ear for your wishes."
    },
    // USP
    usp: {
      title: "Why Geis Care",
      label: "Why Geis Care",
      subtitle: "Four pillars of excellent care that set us apart",
      ctaText: "Experience the difference of first-class care",
      ctaButton: "Get in touch now",
      items: [
        {
          title: "Certified Expertise",
          text: "Care at the highest level."
        },
        {
          title: "Discreet & Reliable",
          text: "Trust from the first minute."
        },
        {
          title: "Individual & Human",
          text: "Time, closeness, dignity."
        },
        {
          title: "Calm Connection",
          text: "Honest and unagitated."
        }
      ]
    },
    // Senior Care
    seniorCare: {
      label: "Senior Care",
      title: "Individual Senior Care in Mallorca",
      subtitle: "Professional German-speaking support for an independent life",
      description: "Our senior care services in Mallorca offer comprehensive everyday assistance – from home care to medical appointment accompaniment. We provide home visit nursing with heart and expertise.",
      ctaButton: "Request consultation now",
      items: [
        {
          icon: "home",
          title: "Daily Life Support",
          description: "Assistance with daily routines for better quality of life"
        },
        {
          icon: "medical",
          title: "Medical Appointment Accompaniment",
          description: "Safe and reliable transport to all medical appointments"
        },
        {
          icon: "pill",
          title: "Medication Management",
          description: "Structured administration and intake monitoring"
        },
        {
          icon: "house",
          title: "Household Assistance",
          description: "Support with everyday household tasks"
        },
        {
          icon: "care",
          title: "Personal Care Support",
          description: "Dignified assistance with personal hygiene"
        },
        {
          icon: "heart",
          title: "Companionship",
          description: "Quality time and social connections"
        },
        {
          icon: "walk",
          title: "Walking Accompaniment",
          description: "Guided outdoor activities and fresh air"
        },
        {
          icon: "shopping",
          title: "Shopping Assistance",
          description: "Joint errands and shopping trips"
        }
      ]
    },
    // Services
    services: {
      title: "Our Services. Your All-Round Carefree Package.",
      subtitle: "We offer flexible and individually tailored care packages.",
      categories: [
        {
          title: "Physical Care",
          description: "We support you in all aspects of daily physical care:",
          items: [
            "✓ Personal hygiene (washing, showering, bathing) – with respect for your privacy",
            "✓ Dressing/undressing – supportive, not patronizing",
            "✓ Mobility & activation – to maintain your independence",
            "✓ Medication administration – documented and safe",
            "✓ Wound care – professional and empathetic",
            "✓ Nutrition & hydration – tailored to your needs"
          ],
          footer: "All measures are digitally documented and accessible to relatives in real-time."
        },
        {
          title: "Special Care",
          description: "In addition to basic care, we offer specialized support:",
          items: [
            "✓ Holiday & event accompaniment – so you can enjoy your special moments",
            "✓ Hourly / daily care – flexible according to your needs",
            "✓ 24-hour accompaniment – for intensive support",
            "✓ Social activities & excursions – against loneliness, for joy of life",
            "✓ Accompaniment to medical appointments – with documentation and follow-up"
          ],
          footer: "Each care plan is individually tailored to your situation."
        },
        {
          title: "Relief & Organization",
          description: "We relieve not only those being cared for, but also their relatives:",
          items: [
            "✓ Medical/therapy accompaniment – with complete documentation",
            "✓ Appointment & medication planning – organized and punctual",
            "✓ Family relief (Mallorca & Germany) – you can relax",
            "✓ Digital documentation – real-time access for relatives",
            "✓ Emergency planning & crisis management – you are prepared"
          ],
          footer: "Our caregivers are your eyes and ears on site – and you have full transparency at all times."
        }
      ]
    },
    // ServicesNew (3 pillars)
    servicesNew: {
      label: "Our 3 Pillars",
      ctaQuestion: "Have questions about our services?",
      ctaButton: "Get free consultation now"
    },
    // ServicesDirectory
    servicesDirectory: {
      label: "Service Directory",
      ctaQuestion: "Have questions about our services?",
      ctaButton: "Get free consultation now"
    },
    // Testimonials
    testimonials: {
      title: "What Clients Say",
      items: [
        {
          text: "Mrs. Geis supported us during a difficult time with so much heart and professionalism. We knew our mother was in the best hands.",
          author: "Maria S.",
          location: "Port d'Andratx"
        },
        {
          text: "Finally, care that focuses on the person, not the clock. Absolutely discreet and reliable.",
          author: "Thomas K.",
          location: "Son Vida"
        }
      ]
    },
    // Service Area
    serviceArea: {
      title: "Our Service Area in Mallorca",
      subtitle: "We are here for you in the premium regions of Mallorca",
      regions: [
        "Manacor", "Porto Cristo", "Cala Millor", "Artà", "Capdepera",
        "Santanyí", "Campos", "Son Vida", "Port d'Andratx", "Palma Old Town",
        "and other regions"
      ]
    },
    // Contact
    contact: {
      title: "Let's Talk.",
      subtitle: "We will contact you promptly and discretely to discuss your needs.",
      email: "Email",
      phone: "Phone",
      whatsapp: "Also available via WhatsApp.",
      area: "Service Area",
      areaText: "Manacor, Porto Cristo, Cala Millor, Artà, Capdepera, Santanyí, Campos, Son Vida, Port d'Andratx, Palma Old Town",
      areaExtra: "and other regions of Mallorca",
      formName: "Name",
      formNamePlaceholder: "Your Name",
      formPhone: "Phone",
      formPhonePlaceholder: "+49 ...",
      formEmail: "Email",
      formEmailPlaceholder: "name@example.com",
      formMessage: "Message",
      formMessagePlaceholder: "How can we help you?",
      formPrivacy: "I agree to the processing of my data for the purpose of contact.",
      formPrivacyLink: "(Privacy Policy)",
      formSubmit: "Send Message",
      formConfirmation: "Thank you! We will contact you promptly and discretely."
    },
    // Header
    header: {
      about: "About",
      services: "Services",
      blog: "Blog",
      why: "Why Us",
      contact: "Contact",
      shop: "Shop"
    },
    // For Whom
    forWhom: {
      title: "The perfect solution for...",
      subtitle: "...everyone who desires loving and reliable support.",
      cards: [
        {
          title: "Seniors in Mallorca",
          text: "...who want to maintain their independence and live safely in their familiar environment. With GEIS CARE, you receive the support you need – without losing your freedom."
        },
        {
          title: "Relatives in DACH Region",
          text: "...who want to ensure the best possible care for their loved ones from afar while being relieved. Our digital documentation gives you peace of mind – you know everything is in the best hands."
        },
        {
          title: "Long-term Vacationers & Overwinterers",
          text: "...who don't want to compromise on safety and social contacts during their stay in Mallorca. Enjoy your dream of Mallorca – we take care of your safety and well-being."
        },
        {
          title: "Grandchildren & Friends",
          text: "...who want to give their grandparents meaningful gifts from our shops. Don't just give a product – give attention and love."
        }
      ]
    },
    // Digital Products
    digitalProducts: {
      title: "Knowledge that provides security.",
      text1: "Discover our digital helpers for everyday care – from emergency checklists to legally sound templates.",
      text2: "In our main shop you'll find a growing library of immediately available digital products that help you better organize everyday care, avoid legal pitfalls, and relieve yourself. Created by experts, refined by AI.",
      text3: "Each product has been carefully developed to solve real problems:",
      items: [
        "Emergency manuals for quick action",
        "Checklists to avoid medication errors",
        "Legal templates for security",
        "Video courses for practical knowledge"
      ],
      cta: "To Main Shop"
    },
    // Gift Boxes
    giftBoxes: {
      title: "Mediterranean quality from the heart of nature.",
      text1: "Discover our handpicked products – organic herbal teas, essential oils and fine home textiles from the Mediterranean.",
      subtitle: "From our shop:",
      items: [
        "MOLY Organic Herbal Teas – Ironwort, Lemon Balm, Digestion & more",
        "Organic Essential Oils – Lavender, Eucalyptus, Peppermint, Orange",
        "Premium Home Textiles – Blankets, Cushions, Mats (recycled & handwoven)",
        "Digital Emergency Preparedness Folder for Relatives"
      ],
      note: "All products are carefully selected – for well-being, dignity and quality of life.",
      cta1: "To Shop",
      cta2: "To TikTok Shop"
    },
    // Process
    process: {
      title: "In 3 steps to worry-free care.",
      subtitle: "Our process is simple, transparent, and tailored to your needs.",
      steps: [
        {
          title: "Free Initial Consultation",
          text: "You describe your situation. We listen and together develop an initial idea for the right support. No hidden costs, no obligation – just honest advice.",
          duration: "Duration: Approx. 20-30 minutes (by phone or in person)"
        },
        {
          title: "Personal Needs Analysis",
          text: "We create a detailed on-site analysis of needs and wishes to develop a customized care concept. This is the foundation for a perfect match.",
          duration: "Duration: Approx. 1-2 hours"
        },
        {
          title: "Start of Care",
          text: "Our carefully selected caregiver begins the care. As a family member, you receive access to digital documentation and have full transparency at all times. Care runs continuously and is regularly optimized.",
          duration: "Duration: Ongoing"
        }
      ]
    },
    // FAQ
    faq: {
      title: "Frequently Asked Questions",
      subtitle: "Here you'll find answers to the most important questions about GEIS CARE.",
      items: [
        {
          question: "What does care through GEIS CARE cost?",
          answer: "Costs vary depending on the scope and type of care. In our free initial consultation, we create an individual offer tailored exactly to your needs. We place great emphasis on transparency – there are no hidden costs."
        },
        {
          question: "How does digital documentation work?",
          answer: "All care measures are digitally documented in real-time. As a family member, you receive access to a secure platform where you can always see which measures were carried out, how your relative is doing, and which appointments are upcoming. This gives you full transparency at all times."
        },
        {
          question: "What qualifications do your caregivers have?",
          answer: "All our caregivers are certified nurses with several years of professional experience. Tutku Geis, our founder, has 15 years of experience in intensive care and surgical nursing. We place great emphasis on continuous training and human competence."
        },
        {
          question: "Can you also step in at short notice?",
          answer: "Yes, in many cases we can also offer support at short notice. Contact us by phone or WhatsApp, and we'll find a solution together. For emergencies, we have a special standby system."
        },
        {
          question: "Do you also work with German doctors and therapists?",
          answer: "Yes, we have an excellent network of German-speaking doctors, therapists, and specialists in Mallorca. If needed, we accompany you to appointments and ensure that all medical information is correctly documented and communicated."
        },
        {
          question: "Do you also offer care for people with dementia?",
          answer: "Yes, we have special experience in caring for people with dementia and other cognitive impairments. Our caregivers are trained in dealing with challenging behavior and place great emphasis on dignified, empathetic accompaniment."
        }
      ],
      extraQuestion: "Have more questions?",
      cta: "Contact Us"
    },
    // Privacy & Impressum
    privacy: {
      backButton: "Back to Homepage",
      title: "Privacy Policy"
    },
    impressum: {
      backButton: "Back to Homepage",
      title: "Legal Notice"
    },
    // Blog
    blog: {
      title: "Knowledge & Insights",
      subtitle: "Current articles about care, support and life in Mallorca.",
      readMore: "Read more",
      showLess: "Show less"
    },
    // Cookie Banner
    cookies: {
      title: "Cookies & Privacy",
      description: "We use cookies to operate our website securely and to improve your experience. Technically necessary cookies are set on the basis of our legitimate interests. All other cookies are only used if you give your consent. For more details, please see our privacy policy.",
      acceptAll: "Accept all",
      rejectAll: "Only necessary cookies",
      settings: "Settings",
      savePreferences: "Save selection",
      privacyLink: "Privacy policy",
      settingsTitle: "Cookie Settings",
      necessary: "Necessary cookies",
      necessaryDesc: "These cookies are required for the basic functioning of the website.",
      alwaysActive: "Always active",
      statistics: "Statistics",
      statisticsDesc: "Help us understand how visitors interact with the website to improve it.",
      marketing: "Marketing",
      marketingDesc: "Used to show visitors relevant advertising and marketing campaigns."
    },

    // Footer
    footer: {
      tagline: "Exclusive Care & Accompaniment in Mallorca",
      impressum: "Legal Notice",
      privacy: "Privacy",
      cookieSettings: "Cookie",
      contact: "Contact",
      rights: "All rights reserved.",
      quickLinks: "Quick Links",
      about: "About Us",
      services: "Services",
      testimonials: "Testimonials",
      followUs: "Follow Us",
      contactTitle: "Contact",
      whatsapp: "WhatsApp available",
      madeWith: "Made with",
      inMallorca: "in Mallorca",
      developedWith: "Developed with",
      forCare: "for premium care",
      seoTitle: "Our Services",
      seoKeywords: [
        "Home Care Mallorca",
        "Elderly Assistance Mallorca",
        "Daily Support Mallorca",
        "Medical Accompaniment Mallorca",
        "German-speaking Care Mallorca"
      ]
    }
  },
  es: {
    // Meta
    meta: {
      title: "Atención domiciliaria y apoyo diario en Mallorca para residentes internacionales | Geis Care",
      description: "Enfermera certificada con 15+ años de experiencia ofrece cuidado domiciliario Mallorca, acompañamiento médico Mallorca, ayuda diaria Mallorca – cuidado personal, movilidad, cuidado de heridas, atención 24h.",
      keywords: "cuidado domiciliario Mallorca, acompañamiento médico Mallorca, ayuda diaria Mallorca, atención a mayores Mallorca, enfermera alemana Mallorca, cuidado 24h Mallorca"
    },
    // Hero
    hero: {
      title: "Cuidado y Acompañamiento Exclusivo en Mallorca",
      subtitle: "Enfermería Certificada – tranquila, atenta, profesional.",
      cta1: "Solicitar Consulta Inicial",
      cta2: "Ver Servicios",
      tagline: "Dignidad. Competencia. Confianza.",
      titlePart1: "Cuidado ",
      titlePart2: " Acompañamiento Exclusivo en Mallorca",
      urgency: "Solo quedan 3 plazas para abril",
      badge1: "15+ Años de Experiencia",
      badge2: "Enfermería Certificada",
      badge3: "Atención 24/7",
      scroll: "Scroll"
    },
    // About
    about: {
      title: "Sobre Tutku Geis",
      text1: "Soy Tutku Geis, enfermera certificada de Alemania con más de 15 años de experiencia en cuidados intensivos y enfermería quirúrgica. Acompaño a las personas con calma, dignidad y corazón.",
      text2: "Con Geis Care, le ofrezco atención que va más allá de lo ordinario: personal, individual y con un oído abierto para sus deseos."
    },
    // USP
    usp: {
      title: "Por qué Geis Care",
      label: "Por qué Geis Care",
      subtitle: "Cuatro pilares de atención excelente que nos distinguen",
      ctaText: "Experimente la diferencia de una atención de primera clase",
      ctaButton: "Contactar ahora",
      items: [
        {
          title: "Experiencia Certificada",
          text: "Atención del más alto nivel."
        },
        {
          title: "Discreta y Confiable",
          text: "Confianza desde el primer minuto."
        },
        {
          title: "Individual y Humana",
          text: "Tiempo, cercanía, dignidad."
        },
        {
          title: "Conexión Tranquila",
          text: "Honesta y serena."
        }
      ]
    },
    // Senior Care
    seniorCare: {
      label: "Atención a Mayores",
      title: "Atención Personalizada para Personas Mayores en Mallorca",
      subtitle: "Apoyo profesional de habla alemana para una vida independiente",
      description: "Nuestros servicios de atención para personas mayores en Mallorca ofrecen asistencia integral en el día a día – desde el cuidado en casa hasta el acompañamiento a citas médicas. Ofrecemos visitas domiciliarias de enfermería con corazón y experiencia.",
      ctaButton: "Solicitar consulta ahora",
      items: [
        {
          icon: "home",
          title: "Apoyo en la Vida Diaria",
          description: "Ayuda con las rutinas diarias para mejor calidad de vida"
        },
        {
          icon: "medical",
          title: "Acompañamiento a Citas Médicas",
          description: "Transporte seguro y confiable a todas las citas médicas"
        },
        {
          icon: "pill",
          title: "Organización de Medicamentos",
          description: "Gestión estructurada y seguimiento de la toma"
        },
        {
          icon: "house",
          title: "Ayuda en el Hogar",
          description: "Apoyo con tareas domésticas cotidianas"
        },
        {
          icon: "care",
          title: "Apoyo en el Cuidado Personal",
          description: "Asistencia digna con la higiene personal"
        },
        {
          icon: "heart",
          title: "Compañía",
          description: "Tiempo de calidad y conexiones sociales"
        },
        {
          icon: "walk",
          title: "Paseos",
          description: "Actividades al aire libre guiadas"
        },
        {
          icon: "shopping",
          title: "Acompañamiento de Compras",
          description: "Recados y compras conjuntas"
        }
      ]
    },
    // Services
    services: {
      title: "Nuestros Servicios. Su Paquete Sin Preocupaciones.",
      subtitle: "Ofrecemos paquetes de atención flexibles y personalizados.",
      categories: [
        {
          title: "Cuidado Físico",
          description: "Le apoyamos en todos los aspectos del cuidado físico diario:",
          items: [
            "✓ Higiene personal (lavar, duchar, bañar) – con respeto a su privacidad",
            "✓ Vestirse/desvestirse – de apoyo, no paternalista",
            "✓ Movilidad y activación – para mantener su independencia",
            "✓ Administración de medicamentos – documentada y segura",
            "✓ Cuidado de heridas – profesional y empático",
            "✓ Nutrición e hidratación – adaptada a sus necesidades"
          ],
          footer: "Todas las medidas se documentan digitalmente y son accesibles para los familiares en tiempo real."
        },
        {
          title: "Atención Especial",
          description: "Además de la atención básica, ofrecemos apoyo especializado:",
          items: [
            "✓ Acompañamiento en vacaciones y eventos – para que disfrute sus momentos especiales",
            "✓ Atención por horas/diaria – flexible según sus necesidades",
            "✓ Acompañamiento 24 horas – para apoyo intensivo",
            "✓ Actividades sociales y excursiones – contra la soledad, por la alegría de vivir",
            "✓ Acompañamiento a citas médicas – con documentación y seguimiento"
          ],
          footer: "Cada plan de atención se adapta individualmente a su situación."
        },
        {
          title: "Alivio y Organización",
          description: "Aliviamos no solo a quienes reciben atención, sino también a sus familiares:",
          items: [
            "✓ Acompañamiento médico/terapéutico – con documentación completa",
            "✓ Planificación de citas y medicación – organizada y puntual",
            "✓ Alivio familiar (Mallorca y Alemania) – puede relajarse",
            "✓ Documentación digital – acceso en tiempo real para familiares",
            "✓ Planificación de emergencias y gestión de crisis – está preparado"
          ],
          footer: "Nuestros cuidadores son sus ojos y oídos en el lugar – y tiene total transparencia en todo momento."
        }
      ]
    },
    // ServicesNew (3 pillars)
    servicesNew: {
      label: "Nuestros 3 Pilares",
      ctaQuestion: "¿Tiene preguntas sobre nuestros servicios?",
      ctaButton: "Solicitar asesoramiento gratuito"
    },
    // ServicesDirectory
    servicesDirectory: {
      label: "Directorio de Servicios",
      ctaQuestion: "¿Tiene preguntas sobre nuestros servicios?",
      ctaButton: "Solicitar asesoramiento gratuito"
    },
    // Testimonials
    testimonials: {
      title: "Lo que Dicen los Clientes",
      items: [
        {
          text: "La Sra. Geis nos apoyó durante un tiempo difícil con tanto corazón y profesionalismo. Sabíamos que nuestra madre estaba en las mejores manos.",
          author: "Maria S.",
          location: "Port d'Andratx"
        },
        {
          text: "Finalmente, atención que se centra en la persona, no en el reloj. Absolutamente discreta y confiable.",
          author: "Thomas K.",
          location: "Son Vida"
        }
      ]
    },
    // Service Area
    serviceArea: {
      title: "Nuestra Área de Servicio en Mallorca",
      subtitle: "Estamos aquí para usted en las regiones premium de Mallorca",
      regions: [
        "Manacor", "Porto Cristo", "Cala Millor", "Artà", "Capdepera",
        "Santanyí", "Campos", "Son Vida", "Port d'Andratx", "Palma Casco Antiguo",
        "y otras regiones"
      ]
    },
    // Contact
    contact: {
      title: "Hablemos.",
      subtitle: "Nos pondremos en contacto con usted de manera rápida y discreta para discutir sus necesidades.",
      email: "Correo electrónico",
      phone: "Teléfono",
      whatsapp: "También disponible por WhatsApp.",
      area: "Área de Servicio",
      areaText: "Manacor, Porto Cristo, Cala Millor, Artà, Capdepera, Santanyí, Campos, Son Vida, Port d'Andratx, Palma Casco Antiguo",
      areaExtra: "y otras regiones de Mallorca",
      formName: "Nombre",
      formNamePlaceholder: "Su Nombre",
      formPhone: "Teléfono",
      formPhonePlaceholder: "+34 ...",
      formEmail: "Correo electrónico",
      formEmailPlaceholder: "nombre@ejemplo.com",
      formMessage: "Mensaje",
      formMessagePlaceholder: "¿Cómo podemos ayudarle?",
      formPrivacy: "Acepto el procesamiento de mis datos con el fin de contacto.",
      formPrivacyLink: "(Política de Privacidad)",
      formSubmit: "Enviar Mensaje",
      formConfirmation: "¡Gracias! Nos pondremos en contacto con usted de manera rápida y discreta."
    },
    // Header
    header: {
      about: "Sobre Nosotros",
      services: "Servicios",
      blog: "Blog",
      why: "Por Qué Nosotros",
      contact: "Contacto",
      shop: "Tienda"
    },
    // For Whom
    forWhom: {
      title: "La solución perfecta para...",
      subtitle: "...todos los que desean un apoyo amoroso y confiable.",
      cards: [
        {
          title: "Personas Mayores en Mallorca",
          text: "...que quieren mantener su independencia y vivir de forma segura en su entorno familiar. Con GEIS CARE, recibe el apoyo que necesita – sin perder su libertad."
        },
        {
          title: "Familiares en Región DACH",
          text: "...que quieren asegurar la mejor atención posible para sus seres queridos desde la distancia mientras son aliviados. Nuestra documentación digital le da tranquilidad – sabe que todo está en las mejores manos."
        },
        {
          title: "Vacacionistas de Larga Estancia e Invernantes",
          text: "...que no quieren renunciar a la seguridad y los contactos sociales durante su estancia en Mallorca. Disfrute de su sueño de Mallorca – nosotros cuidamos de su seguridad y bienestar."
        },
        {
          title: "Nietos y Amigos",
          text: "...que quieren alegrar a sus abuelos con regalos significativos de nuestras tiendas. No solo regale un producto – regale atención y amor."
        }
      ]
    },
    // Digital Products
    digitalProducts: {
      title: "Conocimiento que brinda seguridad.",
      text1: "Descubra nuestros ayudantes digitales para el cuidado diario – desde listas de verificación de emergencia hasta plantillas legalmente sólidas.",
      text2: "En nuestra tienda principal encontrará una biblioteca creciente de productos digitales inmediatamente disponibles que le ayudan a organizar mejor el cuidado diario, evitar trampas legales y aliviarse. Creados por expertos, refinados por IA.",
      text3: "Cada producto ha sido cuidadosamente desarrollado para resolver problemas reales:",
      items: [
        "Manuales de emergencia para acción rápida",
        "Listas de verificación para evitar errores de medicación",
        "Plantillas legales para seguridad",
        "Cursos en video para conocimiento práctico"
      ],
      cta: "A la Tienda Principal"
    },
    // Gift Boxes
    giftBoxes: {
      title: "Calidad mediterránea del corazón de la naturaleza.",
      text1: "Descubra nuestros productos seleccionados a mano – tés de hierbas orgánicas, aceites esenciales y finos textiles del hogar del Mediterráneo.",
      subtitle: "De nuestra tienda:",
      items: [
        "Tés de Hierbas BIO MOLY – Ironwort, Melisa, Digestión y más",
        "Aceites Esenciales BIO – Lavanda, Eucalipto, Menta, Naranja",
        "Textiles Premium para el Hogar – Mantas, Cojines, Alfombras (reciclados y tejidos a mano)",
        "Carpeta Digital de Emergencias para Familiares"
      ],
      note: "Todos los productos están cuidadosamente seleccionados – para el bienestar, la dignidad y la calidad de vida.",
      cta1: "A la Tienda",
      cta2: "A la Tienda TikTok"
    },
    // Process
    process: {
      title: "En 3 pasos hacia la atención sin preocupaciones.",
      subtitle: "Nuestro proceso es simple, transparente y adaptado a sus necesidades.",
      steps: [
        {
          title: "Consulta Inicial Gratuita",
          text: "Usted describe su situación. Escuchamos y juntos desarrollamos una idea inicial para el apoyo adecuado. Sin costos ocultos, sin obligación – solo asesoramiento honesto.",
          duration: "Duración: Aprox. 20-30 minutos (por teléfono o en persona)"
        },
        {
          title: "Análisis Personal de Necesidades",
          text: "Creamos un análisis detallado en el lugar de las necesidades y deseos para desarrollar un concepto de atención personalizado. Esta es la base para una coincidencia perfecta.",
          duration: "Duración: Aprox. 1-2 horas"
        },
        {
          title: "Inicio de la Atención",
          text: "Nuestro cuidador cuidadosamente seleccionado comienza la atención. Como familiar, recibe acceso a la documentación digital y tiene total transparencia en todo momento. La atención se ejecuta continuamente y se optimiza regularmente.",
          duration: "Duración: Continua"
        }
      ]
    },
    // FAQ
    faq: {
      title: "Preguntas Frecuentes",
      subtitle: "Aquí encontrará respuestas a las preguntas más importantes sobre GEIS CARE.",
      items: [
        {
          question: "¿Cuánto cuesta la atención a través de GEIS CARE?",
          answer: "Los costos varían según el alcance y tipo de atención. En nuestra consulta inicial gratuita, creamos una oferta individual adaptada exactamente a sus necesidades. Ponemos gran énfasis en la transparencia – no hay costos ocultos."
        },
        {
          question: "¿Cómo funciona la documentación digital?",
          answer: "Todas las medidas de atención se documentan digitalmente en tiempo real. Como familiar, recibe acceso a una plataforma segura donde siempre puede ver qué medidas se llevaron a cabo, cómo está su familiar y qué citas están próximas. Esto le da total transparencia en todo momento."
        },
        {
          question: "¿Qué calificaciones tienen sus cuidadores?",
          answer: "Todos nuestros cuidadores son enfermeras certificadas con varios años de experiencia profesional. Tutku Geis, nuestra fundadora, tiene 15 años de experiencia en cuidados intensivos y enfermería quirúrgica. Ponemos gran énfasis en la formación continua y la competencia humana."
        },
        {
          question: "¿Pueden también intervenir con poca antelación?",
          answer: "Sí, en muchos casos también podemos ofrecer apoyo con poca antelación. Contáctenos por teléfono o WhatsApp, y encontraremos una solución juntos. Para emergencias, tenemos un sistema especial de guardia."
        },
        {
          question: "¿También trabajan con médicos y terapeutas alemanes?",
          answer: "Sí, tenemos una excelente red de médicos, terapeutas y especialistas de habla alemana en Mallorca. Si es necesario, le acompañamos a las citas y nos aseguramos de que toda la información médica esté correctamente documentada y comunicada."
        },
        {
          question: "¿También ofrecen atención para personas con demencia?",
          answer: "Sí, tenemos experiencia especial en el cuidado de personas con demencia y otras deficiencias cognitivas. Nuestros cuidadores están capacitados para lidiar con comportamientos desafiantes y ponen gran énfasis en el acompañamiento digno y empático."
        }
      ],
      extraQuestion: "¿Tiene más preguntas?",
      cta: "Contáctenos"
    },
    // Privacy & Impressum
    privacy: {
      backButton: "Volver a la Página Principal",
      title: "Política de Privacidad"
    },
    impressum: {
      backButton: "Volver a la Página Principal",
      title: "Aviso Legal"
    },
    // Blog
    blog: {
      title: "Conocimiento y Perspectivas",
      subtitle: "Artículos actuales sobre cuidado, apoyo y vida en Mallorca.",
      readMore: "Leer más",
      showLess: "Mostrar menos"
    },
    // Cookie Banner
    cookies: {
      title: "Cookies y protección de datos",
      description: "Utilizamos cookies para operar nuestro sitio web de forma segura y mejorar su experiencia. Las cookies técnicamente necesarias se establecen sobre la base de nuestro interés legítimo. Todas las demás cookies solo se utilizan si usted da su consentimiento. Encontrará más información en nuestra política de privacidad.",
      acceptAll: "Aceptar todas",
      rejectAll: "Solo cookies necesarias",
      settings: "Ajustes",
      savePreferences: "Guardar selección",
      privacyLink: "Política de privacidad",
      settingsTitle: "Configuración de cookies",
      necessary: "Cookies necesarias",
      necessaryDesc: "Estas cookies son necesarias para el funcionamiento básico del sitio web.",
      alwaysActive: "Siempre activa",
      statistics: "Estadísticas",
      statisticsDesc: "Nos ayudan a comprender cómo los visitantes interactúan con el sitio web para mejorarlo.",
      marketing: "Marketing",
      marketingDesc: "Se utilizan para mostrar a los visitantes publicidad y campañas de marketing relevantes."
    },

    // Footer
    footer: {
      tagline: "Cuidado y Acompañamiento Exclusivo en Mallorca",
      impressum: "Aviso Legal",
      privacy: "Privacidad",
      cookieSettings: "Cookie",
      contact: "Contacto",
      rights: "Todos los derechos reservados.",
      quickLinks: "Enlaces Rápidos",
      about: "Sobre Nosotros",
      services: "Servicios",
      testimonials: "Opiniones",
      followUs: "Síguenos",
      contactTitle: "Contacto",
      whatsapp: "WhatsApp disponible",
      madeWith: "Hecho con",
      inMallorca: "en Mallorca",
      developedWith: "Desarrollado con",
      forCare: "para un cuidado de primera",
      seoTitle: "Nuestros Servicios",
      seoKeywords: [
        "Cuidado domiciliario Mallorca",
        "Atención a mayores Mallorca",
        "Ayuda diaria Mallorca",
        "Acompañamiento médico Mallorca",
        "Atención germanoparlante Mallorca"
      ]
    }
  }
};
